// Determine API base URL based on environment
const getApiBaseUrl = (): string => {
  // Use env variable if explicitly set
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Development environment
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5000/api';
  }

  // Production - use same domain with /api proxy
  // This assumes vercel.json is configured to proxy /api to the backend
  if (typeof window !== 'undefined' && window.location.hostname.includes('vercel.app')) {
    return `https://${window.location.hostname}/api`;
  }

  // Fallback to explicit production backend URL
  return 'https://ghafes-library-server.vercel.app/api';
};

export const API_BASE_URL = getApiBaseUrl();

export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/auth/login',
  SIGNUP: '/auth/signup',
  REFRESH: '/auth/refresh',

  // Users
  PROFILE: '/users/profile',
  CHANGE_PASSWORD: '/users/change-password',
  DELETE_ACCOUNT: '/users/account',
  CREATE_ADMIN: '/users/admin',
  GET_CONSUMERS: '/users/consumers',
  GET_ADMINS: '/users/admins',
  USERS: '/users',

  // Books
  BOOKS: '/books',
  DELETED_BOOKS: '/books/deleted',
  UPLOAD_COVER: '/books/upload/cover',
  UPLOAD_FILE: '/books/upload/file',
  READING_SESSIONS: '/reading-sessions',
  READING_SESSIONS_SUMMARY: '/reading-sessions/summary',
};
